import axios from 'axios'
import router from "../../router/router";

const state = {
  step1: {},
  step2: {},
  step3: {},
  quote_id: null,
  currentStep: 1,
  invalidFields: false,
  addresses: null,

}

const mutations = {
  setAddresses(state, value) {
    state.addresses = value
  },
  nextStep(state) {
    state.currentStep++

    if (state.currentStep === 2) {
      if (state.step2.postage_period === null) {
        state.step2.postage_period = 'no_info'
        state.step2.postage_payment = 'advanced'
        state.step2.packets_capacity = '2_3'
        state.step2.needsAccountsSpendUnits = false
        state.step2.lease_option_1 = '6'
        state.step2.lease_option_2 = '3'
        state.step2.quote_confirmation = true
      }
    }
  },
  stepBack(state) {
    state.currentStep--
  },
  setStep(state, step) {
    state.currentStep = step
  },

  updateQuoteId(state, id) {
    console.log(123);
    state.quote_id = id
  },

  updateInvalidFields(state, values) {
    state.invalidFields = values
  },
  updateStep1(state, values) {
    for (let key in values) {
      state.step1[key] = values[key]
      if (state.invalidFields && state.invalidFields[key]) {
        delete state.invalidFields[key]
      }
    }
    if (state.step1.uses_franking_machine === false) {
      state.step1.printer_model_id = 1
    } else {
      if (state.step1.franking_postage_payment === null) {
        state.step1.franking_postage_payment = 'arrears'
      }
    }
    if (state.invalidFields && Object.keys(state.invalidFields).length === 0) {
      state.invalidFields = false
    }
  },
  updateStep2(state, values) {
    for (let key in values) {
      state.step2[key] = values[key]
      if (state.invalidFields && state.invalidFields[key]) {
        delete state.invalidFields[key]
      }

      if (
        state.step2.class1_standard_letters ||
        state.step2.class1_large_100_letters ||
        state.step2.class1_large_100_250_letters ||
        state.step2.class1_large_250_500_letters ||
        state.step2.class1_large_500_750_letters ||
        state.step2.class2_standard_letters ||
        state.step2.class2_large_100_letters ||
        state.step2.class2_large_100_250_letters ||
        state.step2.class2_large_250_500_letters ||
        state.step2.class2_large_500_750_letters
      ) {
        delete state.invalidFields.class1_standard_letters
        delete state.invalidFields.class2_standard_letters
      }


    }

    if (state.invalidFields && Object.keys(state.invalidFields).length === 0) {
      state.invalidFields = false
    }
  },
  updateStep3(state, values) {
    for (let key in values) {
      state.step3[key] = values[key]
      if (state.invalidFields && state.invalidFields[key]) {
        delete state.invalidFields[key]
      }
    }

    if (state.invalidFields && Object.keys(state.invalidFields).length === 0) {
      state.invalidFields = false
    }
  },

  resetStep1(state) {
    state.step1 = {
      machines_amount: null,
      office_address: null,
      office_postcode: null,
      office_house_number: null,
      franking_contract: null,
      franking_indicia: null,
      franking_postage_payment: null,
      printer_model_id: null,
      franking_quadient_plan: null,
      franking_quote_type: null,
      postage_spend_custom: null,
      postage_spend_per_month: null,
      email: null,
      uses_franking_machine: null,
      //partials
      selectedManufacturer: null,
    }
  },
  resetStep2(state) {
    state.step2 = {
      postage_period: null,
      class1_standard_letters: 0,
      class1_large_100_letters: 0,
      class1_large_100_250_letters: 0,
      class1_large_250_500_letters: 0,
      class1_large_500_750_letters: 0,
      class2_standard_letters: 0,
      class2_large_100_letters: 0,
      class2_large_100_250_letters: 0,
      class2_large_250_500_letters: 0,
      class2_large_500_750_letters: 0,
      letters_a_day: null,
      class1_postage_percentage: null,
      class2_postage_percentage: null,
      mailing_volume: null,
      mailing_frequency: null,
      average_packets_a_day: null,
      postage_payment: null,
      packets_capacity: null,
      accounts_amount: null,
      lease_option_1: null,
      lease_option_2: null,
      quote_confirmation: null,
      new_solution_date: null,
      new_solution_custom_date: null,
      //user details
      company_name: null,
      contact_phone: null,
      name: null,
      //partials
      sendsBulkMailings: null,
      needsAccountsSpendUnits: null,
      sliderValue: 0,
      preferences_email: null,
      preferences_phone: null,
      preferences_mail: null,
      preferences_sms: null,
    }
  },
  resetStep3(state) {
    state.step3 = {
      annual_maintenance_package_cost: null,
      lease_start_month: null,
      lease_end_month: null,
      lease_start_year: null,
      lease_end_year: null,
      lease_billing_period: null,
      lease_payments_made: null,
      lease_cost: null,
      service_cost: null,
      lease_frequency: null,
      service_frequency: null,
      invoice_fee_cost: null,
      invoice_fee_frequency: null,
      insurance_fee_cost: null,
      insurance_fee_frequency: null,
    }
  },
}

const getters = {
  maxSteps(state) {
    return state.step1.uses_franking_machine ? 3 : 2
  }
}

const actions = {
  loadQuoteInStep({state, commit}, {quote_id, step}) {
    return new Promise((resolve, reject) => {
      axios.get('/quotes/' + quote_id).then(response => {

        let quote = response.data

        commit('resetStep1')
        commit('resetStep2')
        commit('resetStep3')

        _.each([1, 2, 3], s => {
          let keys = _.keys(state['step' + s])

          let filtered = {}
          _.each(keys, key => {
            filtered[key] = quote[key]
          })
          if (s === 1) {
            filtered['email'] = quote.user.email
            filtered['selectedManufacturer'] = quote.printer.manufacturer_id
          }
          if (s === 2) {
            filtered['name'] = quote.user.name
            filtered['company_name'] = quote.user.company_name
            filtered['contact_phone'] = quote.user.contact_phone

            filtered['needsAccountsSpendUnits'] = quote.accounts_amount ? true : false
            if (quote.class1_postage_percentage) {
              filtered['sliderValue'] = -50 + quote.class1_postage_percentage
            }

            if (quote.user.preferences) {
              filtered['preferences_email'] = quote.user.preferences.preferences_email
              filtered['preferences_phone'] = quote.user.preferences.preferences_phone
              filtered['preferences_mail'] = quote.user.preferences.preferences_mail
              filtered['preferences_sms'] = quote.user.preferences.preferences_sms
            }


          }

          commit('updateStep' + s, filtered)
        })

        commit('updateQuoteId', quote_id)
        commit('setStep', step)

        resolve()
      }).catch(err => reject(err))
    })
  },
  createQuote({state, commit, dispatch}) {
    dispatch('validateForm', 1)
    if (state.invalidFields) return false
    let data = state.step1
    data['step1'] = true
    axios.post('/users', data)
      .then(response => {
        commit('updateQuoteId', response.data.quote_id)
        commit('nextStep')
        // alert('Quote created!')
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        alert('Failed to create quote!')
      })
  },
  updateQuote({state, commit, dispatch}, step = false) {

    dispatch('validateForm', step)
    if (state.invalidFields) return false

    let data = null
    if (!step) data = {...state.step2, ...state.step3}
    else if (step === 1) {
      data = state.step1
      data['step1'] = true
    }
    else if (step === 2) {
      data = state.step2
      data['step2'] = true
    }
    else if (step === 3) {
      data = state.step3
      data['step3'] = true
    }

    let goToResults = step === 3 || (step === 2 && state.step1.uses_franking_machine === false);

    axios.put('/quotes/' + state.quote_id, data).then(response => {
      if (response.status === 202) {
        if (goToResults) {
          router.push({name: 'results.index', params: {quote_id: response.data.uniqid}})
        } else {
          // alert('Quote updated!')
          commit('nextStep')
          window.scrollTo(0, 0);
        }
      }
    }).catch(error => {
      alert('Failed to update quote!')
    })
  },
  findAddress({state, commit}) {
    axios.post('/postcode/search', {
      postcode: state.step1.office_postcode,
      // house_number: state.step1.office_house_number
    })
      .then((response) => {
        console.log(response)
        commit('setAddresses', response.data)
      })
      .catch((error) => {
        alert('We could not find address for this postcode')
      })
  },
  validateForm({state, commit}, step = false) {
    let invalidFields = {}
    commit('updateInvalidFields', false)

    if (step === 1 || !step) {
      if (!state.step1.machines_amount) invalidFields.machines_amount = true
      if (!state.step1.office_postcode) invalidFields.office_postcode = true
      if (!state.step1.office_address) invalidFields.office_address = true

      if (state.step1.uses_franking_machine === null) invalidFields.uses_franking_machine = true

      //Uses franking machine === true
      if (state.step1.uses_franking_machine) {
        if (!state.step1.franking_contract) invalidFields.franking_contract = true
        if (!state.step1.franking_indicia) invalidFields.franking_indicia = true
        if (!state.step1.franking_postage_payment) invalidFields.franking_postage_payment = true
        if (!state.step1.printer_model_id) invalidFields.printer_model_id = true
        if (!state.step1.franking_quote_type) invalidFields.franking_quote_type = true

        //If Quadient (Neopost) is selected
        if (state.step1.selectedManufacturer === 3) {
          if (!state.step1.franking_quadient_plan) invalidFields.franking_quadient_plan = true
        }
        if (!state.step1.postage_spend_custom) invalidFields.postage_spend_custom = true
      }

      if (!state.step1.email) invalidFields.email = true
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let invalidEmails = ['@neopost.co.uk', '@dataquestuk.com', '@osjersey.co.uk', '@altech-solutions.com', '@altodigital.com', '@nslmailing.co.uk', '@kanemailing.com', '@themailingroom.com', '@compareall.ltd.uk', '@apogeecorp.com', '@digitalsolutionsltd.com', '@ommdigital.co.uk', '@gemuk.co.uk', '@twofold.co.uk', '@frama.co.uk', '@gemuk.co.uk', '@nationwidefrankingsense.co.uk', '@kanemailing.com', '@ncs-ltd.com', '@fpmailing.co.uk', '@ecofranking.co.uk', '@mailcoms.co.uk', '@fpmailingec.co.uk', '@fpwestend.co.uk', '@frankedmail.co.uk', '@officefox.org.uk', '@linkmailingsystems.com', '@mymailingroom.com', '@frankingmachineexpers.co.uk', '@fp-midshires.co.uk', '@pb.com', '@fpmailinglandc.co.uk', '@fpmailingcity.co.uk', '@greenfranking.co.uk', '@stamps.com', '@digitalpostsolutions.com', '@documentdatagroup.com', '@totalpost.com', '@ntdltd.com', '@franking.com', '@europeanpostalsystems.co.uk', '@mailserveltd.co.uk', '@northernservices.co.uk', '@nslmailing.co.uk', '@ims-franking.co.uk', '@pro-copy.co.uk', '@ashcroftmailing.co.uk',];
      if (!re.test(state.step1.email)) {
        invalidFields.email = true;
      } else {
        let parts = state.step1.email.split('@')
        let provider = ('@' + parts[1]).toLowerCase().trim()
        if (_.indexOf(invalidEmails, provider) > -1) {
          invalidFields.email = true
        }
      }
    }


    if (step === 2 || !step) {
      if (!state.step2.postage_period) invalidFields.postage_period = true

      if (state.step2.postage_period === 'no_info') {
        if (!state.step2.letters_a_day) invalidFields.letters_a_day = true
      } else {
        if (
          !state.step2.class1_standard_letters &&
          !state.step2.class1_large_100_letters &&
          !state.step2.class1_large_100_250_letters &&
          !state.step2.class1_large_250_500_letters &&
          !state.step2.class1_large_500_750_letters &&
          !state.step2.class2_standard_letters &&
          !state.step2.class2_large_100_letters &&
          !state.step2.class2_large_100_250_letters &&
          !state.step2.class2_large_250_500_letters &&
          !state.step2.class2_large_500_750_letters
        ) {
          invalidFields.class1_standard_letters = true
          invalidFields.class2_standard_letters = true
        }

        if (state.step2.sendsBulkMailings === null) invalidFields.sendsBulkMailings = true
        if (state.step2.sendsBulkMailings) {
          if (!state.step2.mailing_frequency) invalidFields.mailing_frequency = true
          if (!state.step2.mailing_volume) invalidFields.mailing_volume = true
        }
      }

      if (!state.step2.average_packets_a_day) invalidFields.average_packets_a_day = true
      if (!state.step2.postage_payment) invalidFields.postage_payment = true
      if (!state.step2.packets_capacity) invalidFields.packets_capacity = true

      if (state.step2.needsAccountsSpendUnits === null) invalidFields.needsAccountsSpendUnits = true
      if (state.step2.needsAccountsSpendUnits) {
        if (!state.step2.accounts_amount) invalidFields.accounts_amount = true
      }

      if (!state.step2.lease_option_1) invalidFields.lease_option_1 = true
      if (!state.step2.lease_option_2) invalidFields.lease_option_2 = true
      if (state.step2.quote_confirmation === null) invalidFields.quote_confirmation = true

      // if (!state.step2.new_solution_date) invalidFields.new_solution_date = true
      if (state.step2.new_solution_date === 'custom_date') {
        if (!state.step2.new_solution_custom_date) invalidFields.new_solution_custom_date = true
      }

      if (!state.step2.company_name) invalidFields.company_name = true
      if (!state.step2.contact_phone || (state.step2.contact_phone && state.step2.contact_phone.length < 11)) invalidFields.contact_phone = true
      if (!state.step2.name) invalidFields.name = true
    }


    if (step === 3 || !step) {
      if (state.step1.franking_contract === 'no_purchased') {
        if (!state.step3.annual_maintenance_package_cost) invalidFields.annual_maintenance_package_cost = true

      } else {
        if (!state.step3.lease_start_month) invalidFields.lease_start_month = true
        if (!state.step3.lease_start_year) invalidFields.lease_start_year = true

        if (state.step3.lease_end_month === null) invalidFields.lease_end_month = true
        if (state.step3.lease_end_year === null) invalidFields.lease_end_year = true

        if (state.step3.lease_end_month === 0 || state.step3.lease_end_year === 0) {
          if (!state.step3.lease_billing_period) invalidFields.lease_billing_period = true
          if (!state.step3.lease_payments_made) invalidFields.lease_payments_made = true
        }

        if (!state.step3.lease_cost) invalidFields.lease_cost = true
        if (!state.step3.lease_frequency) invalidFields.lease_frequency = true

        if (!state.step3.service_cost) invalidFields.service_cost = true
        if (!state.step3.service_frequency) invalidFields.service_frequency = true

        if (!state.step3.invoice_fee_cost) invalidFields.invoice_fee_cost = true
        if (!state.step3.invoice_fee_frequency) invalidFields.invoice_fee_frequency = true

        if (!state.step3.insurance_fee_cost) invalidFields.insurance_fee_cost = true
        if (!state.step3.insurance_fee_frequency) invalidFields.insurance_fee_frequency = true

      }
    }


    invalidFields = Object.keys(invalidFields).length > 0 ? invalidFields : false
    // invalidFields = false
    if (invalidFields) commit('updateInvalidFields', invalidFields)
  },

}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/QuoteForm.js